// extracted by mini-css-extract-plugin
export default {"header":"ClientPalletBalancesPage_header__SR4ME","searchInput":"ClientPalletBalancesPage_searchInput__jeKDY"};